import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../../components/shared/Layout';
import api from '../../utils/api';
import CVUpload from '../../components/student/CVUpload';
import { calcProfileProgress } from '../../utils/profileProgress';
import { studentAPI } from '../../utils/api';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace('/api', '');

const SKILL_GROUPS = [
  // ── Siber Güvenlik ───────────────────────────────────────────────────────
  { label: '🔴 Sızma Testi & Exploit', skills: ['Metasploit', 'Burp Suite', 'SQLmap', 'Hydra', 'John the Ripper', 'Aircrack-ng', 'BeEF', 'Nikto', 'ExploitDB', 'Cobalt Strike', 'Empire', 'Covenant', 'Havoc C2', 'Sliver', 'Brute Ratel'] },
  { label: '🌐 Ağ & Tarama Araçları', skills: ['Nmap', 'Wireshark', 'Nessus', 'OpenVAS', 'Snort', 'Zeek', 'tcpdump', 'Masscan', 'Zmap', 'Netcat', 'Ettercap', 'Responder', 'Impacket', 'CrackMapExec'] },
  { label: '🕷️ Web Güvenliği', skills: ['OWASP Top 10', 'XSS', 'SQL Injection', 'SSRF', 'CSRF', 'XXE', 'IDOR', 'JWT Attacks', 'OAuth Attacks', 'GraphQL Security', 'API Security', 'CORS', 'SSTI', 'Deserialization', 'Path Traversal'] },
  { label: '🦠 Zararlı Yazılım & Tersine Mühendislik', skills: ['Ghidra', 'IDA Pro', 'x64dbg', 'OllyDbg', 'Cuckoo Sandbox', 'YARA', 'Radare2', 'Binary Ninja', 'dnSpy', 'PE Studio', 'ANY.RUN', 'VirusTotal', 'Frida'] },
  { label: '🛡️ Blue Team & SIEM', skills: ['Splunk', 'ELK Stack', 'QRadar', 'Wazuh', 'Suricata', 'Velociraptor', 'TheHive', 'MISP', 'Cortex', 'Graylog', 'AlienVault OSSIM', 'Microsoft Sentinel', 'Elastic SIEM'] },
  { label: '🔍 Dijital Adli Bilişim (DFIR)', skills: ['Autopsy', 'FTK', 'Volatility', 'Rekall', 'Magnet AXIOM', 'EnCase', 'NetworkMiner', 'Redline', 'KAPE', 'Eric Zimmerman Tools'] },
  { label: '🔐 Kriptografi & PKI', skills: ['OpenSSL', 'GPG', 'PKI', 'TLS/SSL', 'Hash Algorithms', 'AES/RSA', 'Elliptic Curve', 'Certificate Management', 'HSM', 'Hashcat'] },
  { label: '🕵️ OSINT & Sosyal Mühendislik', skills: ['Maltego', 'Shodan', 'Censys', 'theHarvester', 'Recon-ng', 'SpiderFoot', 'OSINT Framework', 'SET', 'Gophish', 'Evilginx'] },
  { label: '☁️ Bulut & Konteyner Güvenliği', skills: ['AWS Security', 'Azure Security', 'GCP Security', 'Docker Security', 'Kubernetes Security', 'Terraform', 'Prowler', 'ScoutSuite', 'Trivy', 'Falco', 'Checkov'] },
  { label: '⚙️ GRC & Uyum', skills: ['ISO 27001', 'NIST CSF', 'KVKK', 'GDPR', 'PCI-DSS', 'SOC 2', 'NIS2', 'Risk Analizi', 'BIA', 'BCMS', 'Denetim'] },
  // ── Yazılım Geliştirme ───────────────────────────────────────────────────
  { label: '🖥️ Programlama Dilleri', skills: ['Python', 'JavaScript', 'TypeScript', 'Java', 'C', 'C++', 'C#', 'Go', 'Rust', 'Kotlin', 'Swift', 'Ruby', 'PHP', 'Bash', 'PowerShell', 'Assembly', 'Perl', 'R', 'Scala'] },
  { label: '🔧 Backend Geliştirme', skills: ['Node.js', 'Express.js', 'Django', 'FastAPI', 'Flask', 'Spring Boot', '.NET Core', 'Laravel', 'NestJS', 'Ruby on Rails', 'GraphQL', 'REST API', 'gRPC', 'WebSocket', 'Microservices'] },
  { label: '🎨 Frontend Geliştirme', skills: ['React', 'Vue.js', 'Angular', 'Next.js', 'Nuxt.js', 'Svelte', 'HTML5', 'CSS3', 'Tailwind CSS', 'TypeScript', 'Redux', 'Zustand', 'Webpack', 'Vite', 'Storybook'] },
  { label: '📱 Mobil Geliştirme', skills: ['React Native', 'Flutter', 'Swift', 'SwiftUI', 'Kotlin', 'Jetpack Compose', 'Expo', 'Android Studio', 'Xcode', 'Firebase', 'Push Notifications'] },
  { label: '🗄️ Veritabanı', skills: ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Elasticsearch', 'SQLite', 'Microsoft SQL Server', 'Oracle DB', 'Cassandra', 'DynamoDB', 'Neo4j', 'Prisma ORM', 'SQLAlchemy'] },
  { label: '🚀 DevOps & CI/CD', skills: ['Docker', 'Kubernetes', 'GitHub Actions', 'GitLab CI', 'Jenkins', 'Ansible', 'Terraform', 'Helm', 'ArgoCD', 'Prometheus', 'Grafana', 'Nginx', 'Linux', 'Git'] },
  { label: '🤖 Veri Bilimi & Yapay Zeka', skills: ['Pandas', 'NumPy', 'Scikit-learn', 'TensorFlow', 'PyTorch', 'Keras', 'Hugging Face', 'LangChain', 'OpenCV', 'Matplotlib', 'Seaborn', 'Jupyter', 'Apache Spark', 'Airflow'] },
  // ── İş Geliştirme & Analitik ─────────────────────────────────────────────
  { label: '📊 Analitik & İş Araçları', skills: ['Google Analytics', 'Power BI', 'Tableau', 'Excel / VBA', 'Looker Studio', 'Mixpanel', 'Amplitude', 'SQL', 'Metabase', 'Notion', 'Confluence'] },
  { label: '📣 Pazarlama & Büyüme', skills: ['SEO', 'SEM / Google Ads', 'Meta Ads', 'LinkedIn Ads', 'HubSpot', 'Mailchimp', 'A/B Testi', 'Canva', 'İçerik Pazarlama', 'Growth Hacking', 'Affiliate Marketing'] },
  { label: '💼 Satış & Ürün', skills: ['CRM', 'Salesforce', 'Jira', 'Figma', 'Product Roadmap', 'OKR', 'Kullanıcı Araştırması', 'A/B Testi', 'Pazar Analizi', 'Sunum Hazırlama', 'LinkedIn Sales Navigator'] },
];

const CERTIFICATIONS = [
  // Siber Güvenlik
  { name: 'CompTIA Security+', category: 'CompTIA' },
  { name: 'CompTIA CySA+', category: 'CompTIA' },
  { name: 'CompTIA PenTest+', category: 'CompTIA' },
  { name: 'CompTIA CASP+', category: 'CompTIA' },
  { name: 'CompTIA Network+', category: 'CompTIA' },
  { name: 'CEH (Certified Ethical Hacker)', category: 'EC-Council' },
  { name: 'CPENT', category: 'EC-Council' },
  { name: 'CHFI', category: 'EC-Council' },
  { name: 'LPT Master', category: 'EC-Council' },
  { name: 'OSCP', category: 'Offensive Security' },
  { name: 'OSEP', category: 'Offensive Security' },
  { name: 'OSWE', category: 'Offensive Security' },
  { name: 'OSED', category: 'Offensive Security' },
  { name: 'OSWP', category: 'Offensive Security' },
  { name: 'OSDA', category: 'Offensive Security' },
  { name: 'eJPT', category: 'eLearnSecurity' },
  { name: 'eCPPT', category: 'eLearnSecurity' },
  { name: 'eWPT', category: 'eLearnSecurity' },
  { name: 'eMAPT', category: 'eLearnSecurity' },
  { name: 'eWPTX', category: 'eLearnSecurity' },
  { name: 'CISSP', category: 'ISC2' },
  { name: 'CCSP', category: 'ISC2' },
  { name: 'SSCP', category: 'ISC2' },
  { name: 'CISM', category: 'ISACA' },
  { name: 'CISA', category: 'ISACA' },
  { name: 'CRISC', category: 'ISACA' },
  { name: 'CDPSE', category: 'ISACA' },
  { name: 'CCNA Security', category: 'Cisco' },
  { name: 'Cisco CyberOps Associate', category: 'Cisco' },
  { name: 'Cisco CyberOps Professional', category: 'Cisco' },
  { name: 'CCNP Security', category: 'Cisco' },
  { name: 'TCM Security PNPT', category: 'TCM' },
  { name: 'GPEN', category: 'GIAC' },
  { name: 'GCIH', category: 'GIAC' },
  { name: 'GCFE', category: 'GIAC' },
  { name: 'GWAPT', category: 'GIAC' },
  { name: 'GREM', category: 'GIAC' },
  { name: 'Google Cybersecurity Certificate', category: 'Google' },
  { name: 'AWS Security Specialty', category: 'AWS' },
  { name: 'Azure Security Engineer', category: 'Microsoft' },
  { name: 'Hack The Box Pro Hacker', category: 'Platform' },
  { name: 'Hack The Box Elite Hacker', category: 'Platform' },
  { name: 'TryHackMe Top 1%', category: 'Platform' },
  // Bulut & Altyapı
  { name: 'AWS Cloud Practitioner', category: 'AWS' },
  { name: 'AWS Solutions Architect Associate', category: 'AWS' },
  { name: 'AWS Developer Associate', category: 'AWS' },
  { name: 'AWS DevOps Engineer', category: 'AWS' },
  { name: 'Azure Fundamentals (AZ-900)', category: 'Microsoft' },
  { name: 'Azure Administrator (AZ-104)', category: 'Microsoft' },
  { name: 'Azure Developer (AZ-204)', category: 'Microsoft' },
  { name: 'Google Cloud Associate', category: 'Google Cloud' },
  { name: 'Google Cloud Professional', category: 'Google Cloud' },
  { name: 'CKA (Kubernetes Administrator)', category: 'CNCF' },
  { name: 'CKAD (Kubernetes Developer)', category: 'CNCF' },
  { name: 'CKS (Kubernetes Security)', category: 'CNCF' },
  { name: 'Docker Certified Associate', category: 'Docker' },
  { name: 'HashiCorp Terraform Associate', category: 'HashiCorp' },
  // Yazılım & Veri
  { name: 'Oracle Java SE Developer', category: 'Oracle' },
  { name: 'MongoDB Developer', category: 'MongoDB' },
  { name: 'Google Data Analytics', category: 'Google' },
  { name: 'IBM Data Science Professional', category: 'IBM' },
  { name: 'TensorFlow Developer', category: 'Google' },
  { name: 'Tableau Desktop Specialist', category: 'Tableau' },
  { name: 'Microsoft Power BI Data Analyst', category: 'Microsoft' },
  { name: 'Databricks Lakehouse Fundamentals', category: 'Databricks' },
  // İş Geliştirme & Proje
  { name: 'Professional Scrum Master (PSM I)', category: 'Scrum.org' },
  { name: 'PMI PMP', category: 'PMI' },
  { name: 'ITIL 4 Foundation', category: 'ITIL' },
  { name: 'Google Analytics Individual', category: 'Google' },
  { name: 'HubSpot Inbound Marketing', category: 'HubSpot' },
  { name: 'Meta Social Media Marketing', category: 'Meta' },
  { name: 'ISO 27001 Lead Implementer', category: 'ISO' },
  { name: 'ISO 27001 Lead Auditor', category: 'ISO' },
];

const CERT_CATEGORIES = [...new Set(CERTIFICATIONS.map(c => c.category))];

const FOCUS_AREAS = [
  // Siber Güvenlik
  'Penetration Testing', 'Web Uygulama Güvenliği', 'Ağ Güvenliği', 'Kablosuz Ağ Güvenliği',
  'Zararlı Yazılım Analizi', 'Dijital Adli Bilişim (DFIR)', 'Olay Müdahalesi (IR)',
  'Güvenlik Operasyonları (SOC)', 'Tehdit Avcılığı (Threat Hunting)',
  'Tehdit İstihbaratı (CTI)', 'Bulut Güvenliği', 'Konteyner Güvenliği',
  'Mobil Uygulama Güvenliği', 'IoT Güvenliği', 'ICS/SCADA Güvenliği',
  'Kriptografi', 'Tersine Mühendislik', 'Exploit Geliştirme',
  'Bug Bounty', 'CTF', 'Red Team', 'Blue Team', 'Purple Team',
  'GRC (Governance, Risk, Compliance)', 'ISO 27001', 'KVKK/GDPR',
  'Uygulama Güvenliği (AppSec)', 'Kaynak Kod Analizi', 'API Güvenliği',
  // Yazılım Geliştirme
  'Backend Geliştirme', 'Frontend Geliştirme', 'Full-Stack Geliştirme',
  'Mobil Geliştirme (iOS)', 'Mobil Geliştirme (Android)', 'Cross-Platform Geliştirme',
  'API Tasarımı', 'Mikroservis Mimarisi', 'Veritabanı Yönetimi',
  'DevOps', 'DevSecOps', 'Site Reliability Engineering (SRE)',
  'Veri Bilimi', 'Makine Öğrenmesi', 'Derin Öğrenme',
  'Doğal Dil İşleme (NLP)', 'Büyük Veri (Big Data)', 'MLOps',
  'Gömülü Sistemler', 'Oyun Geliştirme', 'Blockchain & Web3',
  // İş Geliştirme
  'İş Geliştirme', 'Ürün Yönetimi', 'Proje Yönetimi',
  'Dijital Pazarlama', 'SEO / SEM', 'İçerik Pazarlama',
  'Teknik Satış', 'Müşteri Başarısı', 'Büyüme & Analitik',
  'Girişimcilik & Startup', 'Yatırım & VC Analizi',
];

const LANGUAGES = ['Türkçe', 'İngilizce', 'Almanca', 'Fransızca', 'Arapça', 'İspanyolca', 'Rusça', 'Çince'];
const LANG_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'Anadil'];
const CTF_PLATFORMS = ['Hack The Box', 'TryHackMe', 'PicoCTF', 'CTFtime', 'pwn.college', 'PortSwigger Web Academy', 'VulnHub', 'OWASP WebGoat', 'IppSec', 'Root Me'];

const SECTIONS = [
  { id: 'personal', label: '👤 Kişisel Bilgiler' },
  { id: 'academic', label: '🎓 Eğitim' },
  { id: 'focus', label: '🎯 Uzmanlık Alanları' },
  { id: 'skills', label: '🛠️ Teknik Beceriler' },
  { id: 'certs', label: '🏆 Sertifikalar' },
  { id: 'ctf', label: '🚩 CTF & Platformlar' },
  { id: 'experience', label: '💼 İş & Staj Deneyimi' },
  { id: 'projects', label: '💡 Projeler' },
  { id: 'awards', label: '🥇 Ödüller & Başarılar' },
  { id: 'publications', label: '📝 Yayınlar & Yazılar' },
  { id: 'languages', label: '🌍 Yabancı Dil' },
  { id: 'preferences', label: '⚙️ Staj Tercihleri' },
  { id: 'bio', label: '📄 Hakkımda & CV' },
  { id: 'data', label: '🔐 Verilerim (KVKK)' },
];

const StudentProfile = () => {
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [saveError, setSaveError] = useState('');
  const [searchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState(() => {
    const s = searchParams.get('section');
    return SECTIONS.some(sec => sec.id === s) ? s : 'personal';
  });

  useEffect(() => {
    studentAPI.getProfile().then(r => setProfile(r.data));
  }, []);

  const hc = (field, value) => setProfile(p => ({ ...p, [field]: value }));

  const toggle = (field, value) => {
    const cur = profile[field] || [];
    hc(field, cur.includes(value) ? cur.filter(v => v !== value) : [...cur, value]);
  };


  // AUTO-SAVE — profile değiştikçe 3sn debounce, snapshot'a göre değişmemişse atlar
  const lastSavedRef = React.useRef(null);
  React.useEffect(() => {
    if (!profile) return;
    if (lastSavedRef.current === null) { lastSavedRef.current = JSON.stringify(profile); return; }
    const current = JSON.stringify(profile);
    if (current === lastSavedRef.current) return;
    const t = setTimeout(() => {
      studentAPI.updateProfile(profile).then(() => {
        lastSavedRef.current = JSON.stringify(profile);
        setSaved(true);
        setTimeout(() => setSaved(false), 1500);
      }).catch(err => { const msg = err?.response?.data?.error || 'Kaydedilemedi'; setSaveError(msg); setTimeout(() => setSaveError(''), 4000); });
    }, 3000);
    return () => clearTimeout(t);
  }, [profile]);

  const handleSave = async () => {
    setSaving(true);
    setSaveError('');
    try {
      await studentAPI.updateProfile(profile);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch(err) {
      const msg = err?.response?.data?.error || 'Kaydedilemedi, tekrar deneyin.';
      setSaveError(msg);
      setTimeout(() => setSaveError(''), 5000);
    } finally { setSaving(false); }
  };

  // JSONB array helpers
  const getArr = (field) => Array.isArray(profile?.[field]) ? profile[field] : (profile?.[field] ? [] : []);
  const addItem = (field, item) => hc(field, [...getArr(field), item]);
  const removeItem = (field, idx) => hc(field, getArr(field).filter((_, i) => i !== idx));
  const updateItem = (field, idx, key, val) => {
    const arr = [...getArr(field)];
    arr[idx] = { ...arr[idx], [key]: val };
    hc(field, arr);
  };


  const [customSkillInputs, setCustomSkillInputs] = React.useState({});
  const addCustomSkill = (groupLabel, value) => {
    if (!value || !value.trim()) return;
    const v = value.trim();
    const cur = profile.skills || [];
    if (cur.includes(v)) { setCustomSkillInputs(p => ({ ...p, [groupLabel]: '' })); return; }
    hc('skills', [...cur, v]);
    setCustomSkillInputs(p => ({ ...p, [groupLabel]: '' }));
  };

  const inp = { width: '100%', padding: '9px 13px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', outline: 'none' };
  const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 };
  const sec = { background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20, border: '1px solid #e5e7eb' };
  const sectionTitle = { fontSize: 17, fontWeight: 700, color: '#111827', marginBottom: 20, paddingBottom: 12, borderBottom: '2px solid #f3f4f6' };
  const cardStyle = { background: '#f9fafb', borderRadius: 10, padding: 16, marginBottom: 12, border: '1px solid #e5e7eb', position: 'relative' };
  const addBtn = { padding: '8px 16px', background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 500 };
  const removeBtn = { position: 'absolute', top: 12, right: 12, background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '3px 8px', cursor: 'pointer', fontSize: 12 };

  const Chip = ({ label, selected, onClick, color = '#2563eb', bg = '#eff6ff' }) => (
    <button onClick={onClick} type="button" style={{
      padding: '5px 13px', borderRadius: 20, cursor: 'pointer', fontSize: 13,
      border: `1.5px solid ${selected ? color : '#e5e7eb'}`,
      background: selected ? bg : '#fff',
      color: selected ? color : '#374151',
      fontWeight: selected ? 500 : 400,
      transition: 'all 0.15s',
    }}>{label}</button>
  );

  const NavItem = ({ id, label }) => (
    <button onClick={() => setActiveSection(id)} style={{
      width: '100%', textAlign: 'left', padding: '10px 14px', borderRadius: 8,
      background: activeSection === id ? '#eff6ff' : 'transparent',
      color: activeSection === id ? '#2563eb' : '#374151',
      border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: activeSection === id ? 600 : 400,
      borderLeft: activeSection === id ? '3px solid #2563eb' : '3px solid transparent',
    }}>{label}</button>
  );


  if (!profile) return <Layout><p style={{ color: '#6b7280' }}>Yükleniyor...</p></Layout>;

  const progress = calcProfileProgress(profile);
  const certs = Array.isArray(profile.certificates) ? profile.certificates : [];
  const ctfPlatforms = profile.ctf_platforms && typeof profile.ctf_platforms === 'object' ? profile.ctf_platforms : {};
  const langs = Array.isArray(profile.languages) ? profile.languages : [];

  return (
    <Layout>
      {/* Mobile: sticky bölüm seçici + kaydet */}
      <div className="lg:hidden" style={{ position: 'sticky', top: 56, zIndex: 20, background: '#fff', borderBottom: '1px solid #e5e7eb', margin: '-16px -16px 16px -16px', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <select
          value={activeSection}
          onChange={e => setActiveSection(e.target.value)}
          style={{ flex: 1, padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, background: '#fff', color: '#111827' }}
        >
          {SECTIONS.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
        </select>
        <div style={{ textAlign: 'center', minWidth: 48 }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: progress >= 80 ? '#16a34a' : progress >= 50 ? '#d97706' : '#dc2626', lineHeight: 1 }}>%{progress}</div>
          <div style={{ fontSize: 10, color: '#9ca3af' }}>tamamlandı</div>
        </div>
        <button onClick={handleSave} disabled={saving} style={{ padding: '9px 14px', background: saveError ? '#dc2626' : saving ? '#93c5fd' : '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap' }}>
          {saveError ? '! Hata' : saved ? '✓' : saving ? '...' : 'Kaydet'}
        </button>
      </div>

      <div className="profile-shell">

        {/* Sol navigasyon */}
        <div className="profile-sidebar">
          <div style={{ background: '#fff', borderRadius: 12, padding: 16, border: '1px solid #e5e7eb', marginBottom: 16 }}>
            {/* Progress */}
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <div style={{ fontSize: 28, fontWeight: 800, color: progress >= 80 ? '#16a34a' : progress >= 50 ? '#d97706' : '#dc2626' }}>
                %{progress}
              </div>
              <div style={{ fontSize: 12, color: '#6b7280' }}>Profil Tamamlandı</div>
              <div style={{ height: 6, background: '#f3f4f6', borderRadius: 3, marginTop: 8 }}>
                <div style={{ height: '100%', width: `${progress}%`, background: progress >= 80 ? '#16a34a' : progress >= 50 ? '#f59e0b' : '#ef4444', borderRadius: 3, transition: 'width 0.3s' }} />
              </div>
            </div>
            <button onClick={handleSave} disabled={saving} style={{
              width: '100%', padding: '10px', background: saveError ? '#dc2626' : saving ? '#93c5fd' : '#2563eb',
              color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer'
            }}>
              {saveError ? '! Hata' : saved ? '✓ Kaydedildi' : saving ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
            {saveError && <div style={{ marginTop: 8, padding: '6px 10px', background: '#fef2f2', color: '#dc2626', borderRadius: 6, fontSize: 12 }}>{saveError}</div>}
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: 10, border: '1px solid #e5e7eb' }}>
            {SECTIONS.map(s => <NavItem key={s.id} id={s.id} label={s.label} />)}
          </div>
        </div>

        {/* Sağ içerik */}
        <div className="profile-content">

          {/* KİŞİSEL BİLGİLER */}
          {activeSection === 'personal' && (
            <div style={sec}>
              <h2 style={sectionTitle}>👤 Kişisel Bilgiler</h2>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                {[
                  { f: 'first_name', l: 'Ad *' }, { f: 'last_name', l: 'Soyad *' },
                  { f: 'phone', l: 'Telefon' }, { f: 'city', l: 'Şehir' },
                  { f: 'nationality', l: 'Uyruk' },
                ].map(({ f, l }) => (
                  <div key={f}>
                    <label style={lbl}>{l}</label>
                    <input style={inp} value={profile[f] || ''} onChange={e => hc(f, e.target.value)} />
                  </div>
                ))}
                <div>
                  <label style={lbl}>Doğum Tarihi</label>
                  <input type="date" style={inp} value={profile.birth_date ? profile.birth_date.split('T')[0] : ''} onChange={e => hc('birth_date', e.target.value)} />
                </div>
                <div>
                  <label style={lbl}>Cinsiyet</label>
                  <select style={inp} value={profile.gender || ''} onChange={e => hc('gender', e.target.value)}>
                    <option value="">Seçiniz</option>
                    <option>Erkek</option><option>Kadın</option><option>Belirtmek istemiyorum</option>
                  </select>
                </div>
                {profile.gender !== 'Kadın' && (<div>
                  {/* askerlik conditional */}
                  <label style={lbl}>Askerlik Durumu</label>
                  <select style={inp} value={profile.military_status || ''} onChange={e => hc('military_status', e.target.value)}>
                    <option value="">Seçiniz</option>
                    <option>Yapıldı</option><option>Tecilli</option><option>Muaf</option><option>Yapılmadı</option><option>Uygulanmaz</option>
                  </select>
                </div>)}
              </div>
              <div style={{ marginTop: 16 }}>
                <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 14 }}>Sosyal & Profesyonel Linkler</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  {[
                    { f: 'linkedin_url', l: '🔗 LinkedIn URL' },
                    { f: 'github_url', l: '🐙 GitHub URL' },
                    { f: 'website_url', l: '🌐 Kişisel Website' },
                    { f: 'twitter_url', l: '🐦 Twitter / X' },
                  ].map(({ f, l }) => (
                    <div key={f}>
                      <label style={lbl}>{l}</label>
                      <input style={inp} value={profile[f] || ''} onChange={e => hc(f, e.target.value)} placeholder="https://" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* EĞİTİM */}
          {activeSection === 'academic' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🎓 Eğitim Bilgileri</h2>

              {/* Ana Eğitim */}
              <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 14 }}>Lisans / Ön Lisans</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={lbl}>Üniversite *</label>
                  <input style={inp} value={profile.university || ''} onChange={e => hc('university', e.target.value)} />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={lbl}>Bölüm *</label>
                  <input style={inp} value={profile.department || ''} onChange={e => hc('department', e.target.value)} placeholder="örn: Bilgisayar Mühendisliği" />
                </div>
                <div>
                  <label style={lbl}>Sınıf</label>
                  <select style={inp} value={profile.grade || ''} onChange={e => hc('grade', e.target.value)}>
                    <option value="">Seçiniz</option>
                    <option value="1">1. Sınıf</option><option value="2">2. Sınıf</option>
                    <option value="3">3. Sınıf</option><option value="4">4. Sınıf</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Not Ortalaması (4.00)</label>
                  <input type="number" step="0.01" min="0" max="4" style={inp} value={profile.gpa || ''} onChange={e => hc('gpa', e.target.value)} />
                </div>
                <div>
                  <label style={lbl}>Mezuniyet Yılı</label>
                  <input type="number" min="2020" max="2035" style={inp} value={profile.graduation_year || ''} onChange={e => hc('graduation_year', e.target.value)} />
                </div>
              </div>

              {/* Ek Eğitimler */}
              <div style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>Diğer Eğitimler (Yüksek Lisans, Kurs, Bootcamp)</h3>
                  <button style={addBtn} onClick={() => addItem('education_detail', { institution: '', degree: '', field: '', start_date: '', end_date: '', description: '' })}>+ Ekle</button>
                </div>
                {getArr('education_detail').map((edu, i) => (
                  <div key={i} style={cardStyle}>
                    <button style={removeBtn} onClick={() => removeItem('education_detail', i)}>✕</button>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, paddingRight: 40 }}>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Kurum Adı</label>
                        <input style={inp} value={edu.institution || ''} onChange={e => updateItem('education_detail', i, 'institution', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>Derece / Tür</label>
                        <select style={inp} value={edu.degree || ''} onChange={e => updateItem('education_detail', i, 'degree', e.target.value)}>
                          <option value="">Seçiniz</option>
                          <option>Yüksek Lisans</option><option>Doktora</option><option>Kurs</option>
                          <option>Bootcamp</option><option>Sertifika Programı</option><option>Online Eğitim</option>
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Alan / Bölüm</label>
                        <input style={inp} value={edu.field || ''} onChange={e => updateItem('education_detail', i, 'field', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>Başlangıç</label>
                        <input type="month" style={inp} value={edu.start_date || ''} onChange={e => updateItem('education_detail', i, 'start_date', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>Bitiş</label>
                        <input type="month" style={inp} value={edu.end_date || ''} onChange={e => updateItem('education_detail', i, 'end_date', e.target.value)} placeholder="Devam ediyor" />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Açıklama</label>
                        <input style={inp} value={edu.description || ''} onChange={e => updateItem('education_detail', i, 'description', e.target.value)} placeholder="Tez konusu, öğrenilen konular..." />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* UZMANLIK ALANLARI */}
          {activeSection === 'focus' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🎯 Uzmanlık / İlgi Alanları</h2>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>Hangi siber güvenlik alanlarında çalışmak / staj yapmak istiyorsunuz?</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {FOCUS_AREAS.map(area => (
                  <Chip key={area} label={area}
                    selected={(profile.skills || []).includes(area)}
                    onClick={() => toggle('skills', area)}
                    color="#7c3aed" bg="#f5f3ff"
                  />
                ))}
              </div>
            </div>
          )}

          {/* TEKNİK BECERİLER */}
          {activeSection === 'skills' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🛠️ Teknik Araçlar & Beceriler</h2>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>Kullandığınız araç ve teknolojileri seçin. Seviye belirtmek için seçtikten sonra seviyeyi güncelleyebilirsiniz.</p>
              {SKILL_GROUPS.map(group => (
                <div key={group.label} style={{ marginBottom: 24 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1e40af', marginBottom: 10, padding: '6px 12px', background: '#eff6ff', borderRadius: 6, display: 'inline-block' }}>
                    {group.label}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
                    {group.skills.map(skill => {
                      const selected = (profile.skills || []).includes(skill);
                      const level = (profile.skill_levels || {})[skill];
                      return (
                        <div key={skill} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Chip label={skill} selected={selected} onClick={() => toggle('skills', skill)} />
                          {selected && (
                            <select value={level || ''} onChange={e => hc('skill_levels', { ...(profile.skill_levels || {}), [skill]: e.target.value })}
                              style={{ fontSize: 11, padding: '2px 4px', border: '1px solid #d1d5db', borderRadius: 4, color: '#6b7280' }}>
                              <option value="">Seviye</option>
                              <option value="Başlangıç">Başlangıç</option>
                              <option value="Orta">Orta</option>
                              <option value="İleri">İleri</option>
                              <option value="Uzman">Uzman</option>
                            </select>
                          )}
                        </div>
                      );
                    })}
                    <input
                      type="text"
                      placeholder="+ Özel araç ekle, Enter'a bas"
                      value={customSkillInputs[group.label] || ''}
                      onChange={e => setCustomSkillInputs(p => ({ ...p, [group.label]: e.target.value }))}
                      onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addCustomSkill(group.label, customSkillInputs[group.label]); } }}
                      onBlur={e => { if (e.target.value.trim()) addCustomSkill(group.label, e.target.value); }}
                      style={{ flex: '1 1 180px', minWidth: 140, padding: '6px 10px', fontSize: 13, border: '1px dashed #cbd5e1', borderRadius: 6, background: '#f8fafc' }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* SERTİFİKALAR */}
          {activeSection === 'certs' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🏆 Sertifikalar</h2>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>Sahip olduğunuz sertifikaları seçin, ardından detaylarını doldurun.</p>
              {CERT_CATEGORIES.map(cat => (
                <div key={cat} style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8, paddingBottom: 4, borderBottom: '1px solid #f3f4f6' }}>{cat}</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {CERTIFICATIONS.filter(c => c.category === cat).map(({ name }) => (
                      <Chip key={name} label={name} selected={certs.includes(name)}
                        onClick={() => hc('certificates', certs.includes(name) ? certs.filter(c => c !== name) : [...certs, name])}
                        color="#059669" bg="#ecfdf5"
                      />
                    ))}
                  </div>
                </div>
              ))}

              {certs.length > 0 && (
                <div style={{ marginTop: 24 }}>
                  <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 12 }}>Sertifika Detayları</h3>
                  {certs.map((cert, i) => {
                    const detail = (getArr('certificates_detail').find(d => d.name === cert)) || {};
                    const updateDetail = (key, val) => {
                      const arr = getArr('certificates_detail').filter(d => d.name !== cert);
                      hc('certificates_detail', [...arr, { ...detail, name: cert, [key]: val }]);
                    };
                    return (
                      <div key={cert} style={cardStyle}>
                        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 10, color: '#059669' }}>{cert}</div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                          <div>
                            <label style={lbl}>Durum</label>
                            <select style={inp} value={detail.status || ''} onChange={e => updateDetail('status', e.target.value)}>
                              <option value="">Seçiniz</option>
                              <option>Alındı</option><option>Hazırlanıyor</option><option>Hedefleniyor</option>
                            </select>
                          </div>
                          <div>
                            <label style={lbl}>Alınma Tarihi</label>
                            <input type="month" style={inp} value={detail.date || ''} onChange={e => updateDetail('date', e.target.value)} />
                          </div>
                          <div>
                            <label style={lbl}>Sertifika No / ID</label>
                            <input style={inp} value={detail.cert_id || ''} onChange={e => updateDetail('cert_id', e.target.value)} placeholder="opsiyonel" />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* CTF & PLATFORMLAR */}
          {activeSection === 'ctf' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🚩 CTF & Platform Profilleri</h2>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>Aktif olduğunuz platformlardaki kullanıcı adı ve sıralamanızı girin.</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16 }}>
                {CTF_PLATFORMS.map(platform => (
                  <div key={platform} style={{ display: 'grid', gridTemplateColumns: '160px 1fr 1fr 1fr', gap: 12, alignItems: 'end', padding: '12px 16px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>{platform}</div>
                    <div>
                      <label style={lbl}>Kullanıcı Adı</label>
                      <input style={inp} value={ctfPlatforms[platform]?.username || ''} onChange={e => hc('ctf_platforms', { ...ctfPlatforms, [platform]: { ...ctfPlatforms[platform], username: e.target.value } })} placeholder="username" />
                    </div>
                    <div>
                      <label style={lbl}>Sıralama / Rütbe</label>
                      <input style={inp} value={ctfPlatforms[platform]?.rank || ''} onChange={e => hc('ctf_platforms', { ...ctfPlatforms, [platform]: { ...ctfPlatforms[platform], rank: e.target.value } })} placeholder="örn: Pro Hacker, Top 5%" />
                    </div>
                    <div>
                      <label style={lbl}>Puan</label>
                      <input type="number" style={inp} value={ctfPlatforms[platform]?.points || ''} onChange={e => hc('ctf_platforms', { ...ctfPlatforms, [platform]: { ...ctfPlatforms[platform], points: e.target.value } })} placeholder="0" />
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>CTF Yarışmaları</h3>
                  <button style={addBtn} onClick={() => addItem('awards', { type: 'CTF', name: '', organizer: '', date: '', rank: '', description: '' })}>+ CTF Ekle</button>
                </div>
                {getArr('awards').filter(a => a.type === 'CTF').map((award, i) => {
                  const realIdx = getArr('awards').indexOf(award);
                  return (
                    <div key={i} style={cardStyle}>
                      <button style={removeBtn} onClick={() => removeItem('awards', realIdx)}>✕</button>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, paddingRight: 40 }}>
                        <div style={{ gridColumn: '1 / -1' }}>
                          <label style={lbl}>Yarışma Adı</label>
                          <input style={inp} value={award.name || ''} onChange={e => updateItem('awards', realIdx, 'name', e.target.value)} placeholder="örn: HackTheBox Uni CTF 2024" />
                        </div>
                        <div><label style={lbl}>Organizatör</label><input style={inp} value={award.organizer || ''} onChange={e => updateItem('awards', realIdx, 'organizer', e.target.value)} /></div>
                        <div><label style={lbl}>Tarih</label><input type="month" style={inp} value={award.date || ''} onChange={e => updateItem('awards', realIdx, 'date', e.target.value)} /></div>
                        <div><label style={lbl}>Sıralama / Derece</label><input style={inp} value={award.rank || ''} onChange={e => updateItem('awards', realIdx, 'rank', e.target.value)} placeholder="örn: 3. / 500 takım" /></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* İŞ & STAJ DENEYİMİ */}
          {activeSection === 'experience' && (
            <div style={sec}>
              <h2 style={sectionTitle}>💼 İş & Staj Deneyimi</h2>
              <button style={addBtn} onClick={() => addItem('work_experiences', { company: '', position: '', type: 'Staj', start_date: '', end_date: '', current: false, description: '', technologies: '' })}>+ Deneyim Ekle</button>
              <div style={{ marginTop: 16 }}>
                {getArr('work_experiences').map((exp, i) => (
                  <div key={i} style={cardStyle}>
                    <button style={removeBtn} onClick={() => removeItem('work_experiences', i)}>✕</button>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, paddingRight: 40 }}>
                      <div>
                        <label style={lbl}>Şirket / Kurum</label>
                        <input style={inp} value={exp.company || ''} onChange={e => updateItem('work_experiences', i, 'company', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>Pozisyon</label>
                        <input style={inp} value={exp.position || ''} onChange={e => updateItem('work_experiences', i, 'position', e.target.value)} placeholder="örn: Siber Güvenlik Stajyeri" />
                      </div>
                      <div>
                        <label style={lbl}>Tür</label>
                        <select style={inp} value={exp.type || 'Staj'} onChange={e => updateItem('work_experiences', i, 'type', e.target.value)}>
                          <option>Staj</option><option>Part-time</option><option>Full-time</option>
                          <option>Freelance</option><option>Gönüllü</option><option>Araştırma</option>
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Çalışma Yeri</label>
                        <select style={inp} value={exp.location_type || ''} onChange={e => updateItem('work_experiences', i, 'location_type', e.target.value)}>
                          <option value="">Seçiniz</option>
                          <option>Uzaktan</option><option>Ofiste</option><option>Hibrit</option>
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Başlangıç</label>
                        <input type="month" style={inp} value={exp.start_date || ''} onChange={e => updateItem('work_experiences', i, 'start_date', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>Bitiş {exp.current && '(devam ediyor)'}</label>
                        <input type="month" style={inp} value={exp.end_date || ''} onChange={e => updateItem('work_experiences', i, 'end_date', e.target.value)} disabled={exp.current} />
                        <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6, fontSize: 12, color: '#6b7280', cursor: 'pointer' }}>
                          <input type="checkbox" checked={exp.current || false} onChange={e => updateItem('work_experiences', i, 'current', e.target.checked)} />
                          Hâlâ çalışıyorum
                        </label>
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Görev Tanımı</label>
                        <textarea rows={3} style={{ ...inp, resize: 'vertical' }} value={exp.description || ''} onChange={e => updateItem('work_experiences', i, 'description', e.target.value)} placeholder="Yaptığınız işler, kullandığınız araçlar, öğrendikleriniz..." />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Kullanılan Teknolojiler</label>
                        <input style={inp} value={exp.technologies || ''} onChange={e => updateItem('work_experiences', i, 'technologies', e.target.value)} placeholder="örn: Burp Suite, Python, Nessus" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* PROJELER */}
          {activeSection === 'projects' && (
            <div style={sec}>
              <h2 style={sectionTitle}>💡 Projeler</h2>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 14 }}>Güvenlik araçları, CTF çözümleri, kişisel araştırmalar, açık kaynak katkılar...</p>
              <button style={addBtn} onClick={() => addItem('projects', { name: '', type: '', description: '', technologies: '', github_url: '', demo_url: '', date: '', highlights: '' })}>+ Proje Ekle</button>
              <div style={{ marginTop: 16 }}>
                {getArr('projects').map((proj, i) => (
                  <div key={i} style={cardStyle}>
                    <button style={removeBtn} onClick={() => removeItem('projects', i)}>✕</button>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, paddingRight: 40 }}>
                      <div>
                        <label style={lbl}>Proje Adı</label>
                        <input style={inp} value={proj.name || ''} onChange={e => updateItem('projects', i, 'name', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>Proje Türü</label>
                        <select style={inp} value={proj.type || ''} onChange={e => updateItem('projects', i, 'type', e.target.value)}>
                          <option value="">Seçiniz</option>
                          <option>Güvenlik Aracı</option><option>CTF Çözümü / Writeup</option>
                          <option>Araştırma / PoC</option><option>Bug Bounty Bulgusu</option>
                          <option>Açık Kaynak Katkı</option><option>Akademik Proje</option><option>Diğer</option>
                        </select>
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Açıklama</label>
                        <textarea rows={3} style={{ ...inp, resize: 'vertical' }} value={proj.description || ''} onChange={e => updateItem('projects', i, 'description', e.target.value)} placeholder="Projenin amacı, ne yaptığı, öğrendikleriniz..." />
                      </div>
                      <div>
                        <label style={lbl}>Teknolojiler</label>
                        <input style={inp} value={proj.technologies || ''} onChange={e => updateItem('projects', i, 'technologies', e.target.value)} placeholder="Python, Bash, Docker..." />
                      </div>
                      <div>
                        <label style={lbl}>Tarih</label>
                        <input type="month" style={inp} value={proj.date || ''} onChange={e => updateItem('projects', i, 'date', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>GitHub URL</label>
                        <input style={inp} value={proj.github_url || ''} onChange={e => updateItem('projects', i, 'github_url', e.target.value)} placeholder="https://github.com/..." />
                      </div>
                      <div>
                        <label style={lbl}>Demo / Blog URL</label>
                        <input style={inp} value={proj.demo_url || ''} onChange={e => updateItem('projects', i, 'demo_url', e.target.value)} placeholder="https://..." />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Öne Çıkan Başarılar</label>
                        <input style={inp} value={proj.highlights || ''} onChange={e => updateItem('projects', i, 'highlights', e.target.value)} placeholder="örn: 200+ GitHub star, CVE-2024-XXXX bulgusu, HackerOne kabul..." />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ÖDÜLLER & BAŞARILAR */}
          {activeSection === 'awards' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🥇 Ödüller & Başarılar</h2>
              <button style={addBtn} onClick={() => addItem('awards', { type: 'Ödül', name: '', organizer: '', date: '', rank: '', description: '' })}>+ Ekle</button>
              <div style={{ marginTop: 16 }}>
                {getArr('awards').filter(a => a.type !== 'CTF').map((award, i) => {
                  const realIdx = getArr('awards').indexOf(award);
                  return (
                    <div key={i} style={cardStyle}>
                      <button style={removeBtn} onClick={() => removeItem('awards', realIdx)}>✕</button>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, paddingRight: 40 }}>
                        <div>
                          <label style={lbl}>Tür</label>
                          <select style={inp} value={award.type || ''} onChange={e => updateItem('awards', realIdx, 'type', e.target.value)}>
                            <option>Ödül</option><option>Hackathon</option><option>Bug Bounty</option>
                            <option>Burs</option><option>Başarı Belgesi</option><option>Diğer</option>
                          </select>
                        </div>
                        <div>
                          <label style={lbl}>Ödül / Başarı Adı</label>
                          <input style={inp} value={award.name || ''} onChange={e => updateItem('awards', realIdx, 'name', e.target.value)} />
                        </div>
                        <div>
                          <label style={lbl}>Organizatör / Platform</label>
                          <input style={inp} value={award.organizer || ''} onChange={e => updateItem('awards', realIdx, 'organizer', e.target.value)} />
                        </div>
                        <div>
                          <label style={lbl}>Tarih</label>
                          <input type="month" style={inp} value={award.date || ''} onChange={e => updateItem('awards', realIdx, 'date', e.target.value)} />
                        </div>
                        <div style={{ gridColumn: '1 / -1' }}>
                          <label style={lbl}>Açıklama</label>
                          <input style={inp} value={award.description || ''} onChange={e => updateItem('awards', realIdx, 'description', e.target.value)} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* YAYINLAR */}
          {activeSection === 'publications' && (
            <div style={sec}>
              <h2 style={sectionTitle}>📝 Yayınlar, Writeup'lar & Blog Yazıları</h2>
              <button style={addBtn} onClick={() => addItem('publications', { type: 'Blog', title: '', url: '', date: '', platform: '', description: '' })}>+ Ekle</button>
              <div style={{ marginTop: 16 }}>
                {getArr('publications').map((pub, i) => (
                  <div key={i} style={cardStyle}>
                    <button style={removeBtn} onClick={() => removeItem('publications', i)}>✕</button>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, paddingRight: 40 }}>
                      <div>
                        <label style={lbl}>Tür</label>
                        <select style={inp} value={pub.type || ''} onChange={e => updateItem('publications', i, 'type', e.target.value)}>
                          <option>Blog Yazısı</option><option>CTF Writeup</option><option>Araştırma Makalesi</option>
                          <option>CVE / Güvenlik Açığı Raporu</option><option>Teknik Rapor</option><option>Video / Eğitim</option>
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Platform</label>
                        <input style={inp} value={pub.platform || ''} onChange={e => updateItem('publications', i, 'platform', e.target.value)} placeholder="Medium, GitHub, HackerOne..." />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Başlık</label>
                        <input style={inp} value={pub.title || ''} onChange={e => updateItem('publications', i, 'title', e.target.value)} />
                      </div>
                      <div>
                        <label style={lbl}>URL</label>
                        <input style={inp} value={pub.url || ''} onChange={e => updateItem('publications', i, 'url', e.target.value)} placeholder="https://..." />
                      </div>
                      <div>
                        <label style={lbl}>Tarih</label>
                        <input type="month" style={inp} value={pub.date || ''} onChange={e => updateItem('publications', i, 'date', e.target.value)} />
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <label style={lbl}>Özet</label>
                        <input style={inp} value={pub.description || ''} onChange={e => updateItem('publications', i, 'description', e.target.value)} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* YABANCI DİL */}
          {activeSection === 'languages' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🌍 Yabancı Dil</h2>
              <button style={addBtn} onClick={() => hc('languages', [...langs, { language: '', level: '', note: '' }])}>+ Dil Ekle</button>
              <div style={{ marginTop: 16 }}>
                {langs.map((lang, i) => (
                  <div key={i} style={{ ...cardStyle, display: 'grid', gridTemplateColumns: '1fr 1fr 2fr auto', gap: 12, alignItems: 'end' }}>
                    <div>
                      <label style={lbl}>Dil</label>
                      <select style={inp} value={lang.language || ''} onChange={e => { const a = [...langs]; a[i] = { ...a[i], language: e.target.value }; hc('languages', a); }}>
                        <option value="">Seçiniz</option>
                        {LANGUAGES.map(l => <option key={l}>{l}</option>)}
                        <option>Diğer</option>
                      </select>
                    </div>
                    <div>
                      <label style={lbl}>Seviye</label>
                      <select style={inp} value={lang.level || ''} onChange={e => { const a = [...langs]; a[i] = { ...a[i], level: e.target.value }; hc('languages', a); }}>
                        <option value="">Seçiniz</option>
                        {LANG_LEVELS.map(l => <option key={l}>{l}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={lbl}>Not (opsiyonel)</label>
                      <input style={inp} value={lang.note || ''} onChange={e => { const a = [...langs]; a[i] = { ...a[i], note: e.target.value }; hc('languages', a); }} placeholder="IELTS 7.5, TOEFL 100..." />
                    </div>
                    <button onClick={() => hc('languages', langs.filter((_, j) => j !== i))} style={{ padding: '8px 12px', background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, cursor: 'pointer' }}>✕</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* STAJ TERCİHLERİ */}
          {activeSection === 'preferences' && (
            <div style={sec}>
              <h2 style={sectionTitle}>⚙️ Staj Tercihleri</h2>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div>
                  <label style={lbl}>Başlangıç Tarihi</label>
                  <input type="date" style={inp} value={(profile.internship_preferences || {}).start_date || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), start_date: e.target.value })} />
                </div>
                <div>
                  <label style={lbl}>Staj Süresi</label>
                  <select style={inp} value={(profile.internship_preferences || {}).duration || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), duration: e.target.value })}>
                    <option value="">Seçiniz</option>
                    <option>1 ay</option><option>2 ay</option><option>3 ay</option>
                    <option>6 ay</option><option>1 yıl</option><option>Esnek</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Staj Türü</label>
                  <select style={inp} value={(profile.internship_preferences || {}).internship_type || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), internship_type: e.target.value })}>
                    <option value="">Seçiniz</option>
                    <option>Gönüllü</option><option>Zorunlu</option><option>Her ikisi de olur</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Çalışma Şekli</label>
                  <select style={inp} value={(profile.internship_preferences || {}).work_type || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), work_type: e.target.value })}>
                    <option value="">Seçiniz</option>
                    <option>Uzaktan</option><option>Ofiste</option><option>Hibrit</option><option>Fark etmez</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Tercih Edilen Şehir</label>
                  <input style={inp} value={(profile.internship_preferences || {}).preferred_city || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), preferred_city: e.target.value })} placeholder="İstanbul, Ankara, uzaktan..." />
                </div>
                <div>
                  <label style={lbl}>Ücret Beklentisi (Aylık ₺)</label>
                  <input type="number" style={inp} value={(profile.internship_preferences || {}).salary_expectation || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), salary_expectation: e.target.value })} placeholder="0 = ücretsiz kabul edilir" />
                </div>
                <div>
                  <label style={lbl}>Uygunluk</label>
                  <select style={inp} value={(profile.internship_preferences || {}).availability || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), availability: e.target.value })}>
                    <option value="">Seçiniz</option>
                    <option>Hemen başlayabilirim</option><option>1 ay içinde</option>
                    <option>3 ay içinde</option><option>6 ay içinde</option>
                  </select>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={lbl}>Staj yapmak istediğiniz dönemi lütfen seçiniz, bu bağlamda ilgili şirketlerimize profiliniz önerilecektir. Birden fazla seçim yapabilirsiniz.</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 6 }}>
                    {['Uzun Dönem', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül'].map(period => {
                      const selected = ((profile.internship_preferences || {}).internship_periods || []).includes(period);
                      return (
                        <button key={period} type="button"
                          onClick={() => {
                            const cur = (profile.internship_preferences || {}).internship_periods || [];
                            const next = selected ? cur.filter(p => p !== period) : [...cur, period];
                            hc('internship_preferences', { ...(profile.internship_preferences || {}), internship_periods: next });
                          }}
                          style={{ padding: '8px 18px', borderRadius: 20, border: selected ? '2px solid #2563eb' : '1px solid #d1d5db', background: selected ? '#eff6ff' : '#fff', color: selected ? '#1d4ed8' : '#6b7280', fontSize: 13, fontWeight: selected ? 600 : 400, cursor: 'pointer', transition: 'all 0.15s' }}>
                          {period}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={lbl}>Staj Notu / Ek Bilgi</label>
                  <textarea rows={3} style={{ ...inp, resize: 'vertical' }} value={(profile.internship_preferences || {}).notes || ''} onChange={e => hc('internship_preferences', { ...(profile.internship_preferences || {}), notes: e.target.value })} placeholder="Özel tercihleriniz, kısıtlamalarınız veya eklemek istediğiniz bilgiler..." />
                </div>
              </div>
            </div>
          )}

          {/* HAKKIMDA & CV */}
          {activeSection === 'bio' && (
            <div style={sec}>
              <h2 style={sectionTitle}>📄 Hakkımda & CV</h2>
              <div style={{ marginBottom: 20 }}>
                <label style={lbl}>Kısa Özet (Profil Başlığı)</label>
                <input style={inp} value={profile.bio || ''} onChange={e => hc('bio', e.target.value)} placeholder="örn: Siber güvenlik tutkunu, OSCP adayı, aktif CTF oyuncusu" maxLength={200} />
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>{(profile.bio || '').length}/200</div>
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={lbl}>Detaylı Hakkımda</label>
                <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>CTF deneyimleri, bug bounty bulguları, kişisel projeler, motivasyonunuz...</p>
                <textarea rows={8} style={{ ...inp, resize: 'vertical' }} value={profile.about_me || ''} onChange={e => hc('about_me', e.target.value)} placeholder="örn: TryHackMe'de Top %5 sıralamam var, aktif olarak CTF yarışmalarına katılıyorum. HackerOne'da 3 valid raporum bulunuyor. Python ile güvenlik otomasyon araçları geliştiriyorum..." />
              </div>
              <div>
                <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 12 }}>CV / Özgeçmiş</h3>

                <div style={{ marginBottom: 18 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#1d4ed8', marginBottom: 6 }}>🇹🇷 Türkçe CV</div>
                  {profile.cv_file_url && (
                    <div style={{ marginBottom: 8, padding: '8px 12px', background: '#f0fdf4', borderRadius: 8, fontSize: 13, display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span>📎</span>
                      <a href={`${API_BASE}${profile.cv_file_url}`} target="_blank" rel="noreferrer" style={{ color: '#16a34a', fontWeight: 500 }}>Mevcut TR CV'yi Görüntüle</a>
                    </div>
                  )}
                  <CVUpload lang="tr" onSuccess={() => studentAPI.getProfile().then(r => setProfile(r.data))} />
                </div>

                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#1d4ed8', marginBottom: 6 }}>🇬🇧 English CV</div>
                  {profile.cv_file_url_en && (
                    <div style={{ marginBottom: 8, padding: '8px 12px', background: '#f0fdf4', borderRadius: 8, fontSize: 13, display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span>📎</span>
                      <a href={`${API_BASE}${profile.cv_file_url_en}`} target="_blank" rel="noreferrer" style={{ color: '#16a34a', fontWeight: 500 }}>View English CV</a>
                    </div>
                  )}
                  <CVUpload lang="en" onSuccess={() => studentAPI.getProfile().then(r => setProfile(r.data))} />
                </div>
              </div>
            </div>
          )}

          {/* VERİLERİM */}
          {activeSection === 'data' && (
            <div style={sec}>
              <h2 style={sectionTitle}>🔐 Verilerim (KVKK)</h2>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 18, lineHeight: 1.6 }}>
                6698 sayılı KVKK kapsamında verileriniz üzerinde tam kontrol sahibisiniz.
                Bilgilerinizi istediğiniz zaman indirebilir veya hesabınızı kalıcı olarak silebilirsiniz.
              </p>

              <div style={{ padding: 18, background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 10, marginBottom: 14 }}>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: '#0c4a6e', marginBottom: 8 }}>📥 Verilerimi İndir</h3>
                <p style={{ fontSize: 13, color: '#075985', marginBottom: 12 }}>
                  Profil, başvuru, yüklediğiniz CV ve tüm ilişkili verileriniz JSON formatında.
                </p>
                <button onClick={async () => {
                  try {
                    const r = await api.get('/kvkk/export');
                    const blob = new Blob([JSON.stringify(r.data, null, 2)], { type: 'application/json' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a'); a.href = url; a.download = 'my-data.json'; a.click();
                    URL.revokeObjectURL(url);
                  } catch { alert('İndirme başarısız'); }
                }} style={{ padding: '9px 18px', background: '#0284c7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
                  Verilerimi İndir
                </button>
              </div>

              <div style={{ padding: 18, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10 }}>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: '#991b1b', marginBottom: 8 }}>🗑️ Hesabımı Sil</h3>
                <p style={{ fontSize: 13, color: '#b91c1c', marginBottom: 12 }}>
                  <strong>Dikkat:</strong> Hesabınız ve tüm verileriniz (profil, başvurular, CV) kalıcı olarak silinir. Bu işlem <u>geri alınamaz</u>.
                </p>
                <button onClick={async () => {
                  const confirm = prompt('Onaylamak için şunu yazın: HESABIMI-SIL');
                  if (confirm !== 'HESABIMI-SIL') return;
                  try {
                    await api.delete('/kvkk/account', { data: { confirm: 'HESABIMI-SIL' } });
                    alert('Hesabınız silindi. Çıkış yapılıyor.');
                    localStorage.clear();
                    window.location.href = '/';
                  } catch (e) { alert(e.response?.data?.error || 'Silme başarısız'); }
                }} style={{ padding: '9px 18px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
                  Hesabımı Kalıcı Olarak Sil
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </Layout>
  );
};

export default StudentProfile;
